import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export async function getPromotions(uId, payload) {
  const token = await authToken(uId);
  var config = {
    method: 'post',
    url: cfac22('API_HOST_V2') + '/getStorePlace/promotions',
    headers: {
      Authorization: 'Bearer ' + token,
      'Full-Url': window.location.href,
    },
    data: { ...payload },
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then(function (response) {
        resolve(response.data.result);
      })
      .catch(function (error) {
        reject(error.response.data.error);
      });
  });
}

// exemplo de payload
// {
//   "systemQuery": {
//     "grupo1": [
//       {
//         "type": "array_contains",
//         "field": "tags",
//         "value": ["Moda e Acessórios"]
//       }
//     ]
//   },
//   "hasVoucher": true,
//   "productType": ["digital", "physical"],
//   "orderType": "location",
//   "geoFocus": {
//     "lat": "-23.5983184",
//     "long": "-46.641581"
//   },
//   "geoRadius": 10000,
//   "plataform": "web",
//   "from": 0,
//   "size": 100,
//   "userQuery": "teste"
// }
